import LinearPerformance from "./LinearPerformance";

export default LinearPerformance;
